var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import AntDatePicker from "antd/es/date-picker";
import { useGetGerudoContainer } from "../hooks/useGetGerudoContainer";
const { RangePicker } = AntDatePicker;
const LegacyDateRangePicker = (_a) => {
    var { prefix, suffix, className, showTime = false, picker, ref } = _a, props = __rest(_a, ["prefix", "suffix", "className", "showTime", "picker", "ref"]);
    const { ref: pickerRef, getGerudoContainer } = useGetGerudoContainer();
    const classes = classNames("gerudo-datepicker", "gerudo-input", className);
    if (suffix && prefix) {
        // eslint-disable-next-line no-console
        console.warn("Gerudo: DatePicker can only have one of prefix or suffix. Prefix will be used.");
    }
    return (React.createElement("div", { className: classes, ref: pickerRef },
        React.createElement(RangePicker, Object.assign({ className: prefix ? "picker-prefixed" : "", ref: ref, suffixIcon: prefix || suffix, getPopupContainer: () => pickerRef.current || getGerudoContainer(), showTime: showTime, picker: picker }, props))));
};
LegacyDateRangePicker.displayName = "LegacyDateRangePicker";
export default LegacyDateRangePicker;
export { LegacyDateRangePicker };
//# sourceMappingURL=LegacyDateRangePicker.js.map